import { createSelector, createEntityAdapter } from '@reduxjs/toolkit';
import { apiSlice } from '../../app/api/apiSlice';

export const servicesApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        provisionStorageIntegration: builder.mutation({
            query: ({ bucket, prefix, integrationName }) => ({
                url: '/services/create-storage-integration',
                method: 'POST',
                body: {
                    bucket,
                    prefix,
                    integrationName,
                },
            }),
        }),
        provisionStorageIntegrationWithOrg: builder.mutation({
            query: ({ bucket, prefix, integrationName, organizationId }) => ({
                url: '/services/create-storage-integration-with-org',
                method: 'POST',
                body: {
                    bucket,
                    prefix,
                    integrationName,
                    organizationId,
                },
            }),
        }),
    }),
});

export const {
    useProvisionStorageIntegrationMutation,
    useProvisionStorageIntegrationWithOrgMutation,
} = servicesApiSlice;
